var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mtn_apps"}},[_c('div',{staticClass:"apps-back"},[_c('SliderSection',{attrs:{"id":"normal-cards","obj":_vm.mtnAppsRepo,"method":"getPage","sliderHolder":"mtnApps","data":_vm.info}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }